import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/schlusssatz-bewerbung.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')